var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCampaignDashboardIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m7.146 9.646 6-6a.5.5 0 1 1 .708.708l-6 6a.5.5 0 0 1-.708-.708M8 5.5c.434 0 .866.07 1.277.208a.5.5 0 1 0 .32-.947 5 5 0 0 0-6.566 5.294.5.5 0 0 0 .496.445q.027 0 .055-.003a.5.5 0 0 0 .442-.552A4.004 4.004 0 0 1 8 5.5m6.234.812a.501.501 0 0 0-.944.269.5.5 0 0 0 .054.188 6.02 6.02 0 0 1 .312 4.732l-11.318-.005A6.015 6.015 0 0 1 8 3.5h.055c.931.006 1.848.23 2.676.656a.5.5 0 1 0 .457-.89 7 7 0 0 0-9.792 8.563 1 1 0 0 0 .945.67h11.317a1 1 0 0 0 .944-.668 7.02 7.02 0 0 0-.368-5.52z"
})));
export { SvgCampaignDashboardIcon as ReactComponent };
export default __webpack_public_path__ + "c393434fffd2c43c67879ab44264b751.svg";